module.exports = __webpack_public_path__ + "img/Login.0ea183bd.jpg";